<template>
  <div>
    <div class="wrapper wrapper-full-page">
      <div
        class="page-header login-page header-filter"
        filter-color="black"
        style="
        background-image: url('https://www.patristicum.org/pf/QCMS/media/home.jpg');
          background-color: #606cf0;
          background-size: cover;
          background-position: center;
          min-height: 100vh;
          display: flex;
          align-items: center;
        "
      >
        <v-container fluid>
          <!-- Bottoni lingua posizionati in alto a destra -->
          <div class="language-selector">
            <v-btn
              color="white"
              elevation="8"
              fab
              small
              class="mx-1"
              @click="lingua('it')"
              ><div class="text-body-1 font-weight-bold text-black">ITA</div>
            </v-btn>
            <v-btn
              color="white"
              elevation="8"
              fab
              small
              class="mx-1"
              @click="lingua('en')"
              ><div class="text-body-1 font-weight-bold text-black">ENG</div>
            </v-btn>
            <v-btn
              color="white"
              elevation="8"
              fab
              small
              class="mx-1"
              @click="lingua('es')"
              ><div class="text-body-1 font-weight-bold text-black">ESP</div>
            </v-btn>
          </div>

          <section class="login-section">
            <div class="container">
              <div class="row d-flex justify-content-center align-items-center">
                <div class="col-xl-16 pa-2" v-if="getStatoAPI">
                  <div
                    class="card rounded-3 text-black semi-transparent login-card"
                  >
                    <div class="row g-0">
                      <!-- Colonna sinistra: informativa -->
                      <div
                        class="accent col-lg-6 d-flex align-items-center gradient-custom-2 left-panel"
                      >
                        <div class="text-white px-3 py-4 p-md-5 mx-md-4 accent">
                          <div class="text-center mb-5">
                            <v-img
                              src="@/assets/logoAUG.png"
                              max-width="400"
                              max-height="400"
                              contain
                              class="mx-auto d-none d-lg-block"
                            ></v-img>
                          </div>

                          <h3 class="mb-4 font-weight-bold">
                            {{ $t("login.nuovoStudente.titolo") }}
                          </h3>
                          <p class="mb-5 text-body-1">
                            {{ $t("login.nuovoStudente.testo") }}
                          </p>

                          <v-divider class="my-5 white-divider"></v-divider>

                           <h3 class="mb-4 font-weight-bold">
                            {{ $t("login.vecchioStudente.titolo") }}
                          </h3>
                          <p class="mb-5 text-body-1">
                            {{ $t("login.vecchioStudente.testo") }}
                          </p>

                          <div class="d-flex justify-center mt-4">
                            <v-btn
                              @click="goRinnovi"
                              small
                              outlined
                              color="white"
                              class="ma-2"
                            >
                              link alla procedura di rinnovo
                            </v-btn>
                          </div>
                        </div>
                      </div>

                      <!-- Colonna destra: form login -->
                      <div class="col-lg-6 login-form-panel">
                        <div class="card-body p-md-5 mx-md-4">
                          <div class="text-center mb-5"></div>

                          <v-form
                            ref="form"
                            @submit.prevent="onSubmit"
                            v-model="valid"
                            lazy-validation
                            class="login-form"
                          >
                            <h3
                              class="mb-4 text-center gold--text font-weight-bold"
                            >
                              {{ $t("login.titolo") }}
                            </h3>

                            <v-text-field
                              prepend-icon="mdi-email"
                              v-model="form.email"
                              :label="$t('email')"
                              :rules="[rules.required, rules.email]"
                              filled
                              rounded
                              dense
                              class="mb-3 input-field"
                              color="#c8a501"
                              background-color="rgba(255, 255, 255, 0.9)"
                              @input="resetErrors"
                            ></v-text-field>

                            <v-text-field
                              prepend-icon="mdi-lock"
                              v-model="form.password"
                              :label="$t('password')"
                              :type="value ? 'password' : 'text'"
                              :rules="[(v) => !!v || $t('campoObbligatorio')]"
                              :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="() => (value = !value)"
                              filled
                              rounded
                              dense
                              class="mb-4 input-field"
                              color="#c8a501"
                              background-color="rgba(255, 255, 255, 0.9)"
                              @input="resetErrors"
                            ></v-text-field>

                            <v-alert
                              v-if="authErr"
                              class="pa-2 mb-4"
                              type="error"
                              dense
                            >
                              {{ $t("login.loginErrato") }}
                            </v-alert>

                            <div class="d-flex flex-column align-center">
                              <v-btn
                                color="primary"
                                elevation="2"
                                large
                                block
                                @click="checkLogin"
                              >
                                {{ $t("login.accedi") }}
                              </v-btn>

                              <v-btn
                                text
                                small
                                @click="recuperoPassword = true"
                                class="mb-5"
                              >
                                {{ $t("login.forgotPassword") }}
                              </v-btn>
                            </div>

                            <v-divider class="my-4"></v-divider>

                            <div class="text-center mt-4">
                              <p
                                class="mb-3 font-weight-bold text-black text-body-1 blink-text"
                              >
                                {{ $t("login.noRegistrato") }}
                              </p>
                              <v-btn
                                outlined
                                @click="nuovoUtente = true"
                                class="registration-btn"
                                elevation="2"
                                large
                              >
                                {{ $t("login.registrati") }}
                              </v-btn>
                            </div>
                          </v-form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else class="pa-2">
                  <v-alert
                    color="#c8a501"
                    dark
                    icon="mdi-monitor-lock"
                    border="left"
                    prominent
                    class="text-h6"
                  >
                    {{ $t("chiuse") }}
                  </v-alert>
                </div>
              </div>
            </div>
          </section>

          <p class="text-center text-overline mt-4 white--text">
            Augustinianum - V.1.0
          </p>
        </v-container>
      </div>

      <keep-alive>
        <nuovo-utente
          :attivo="nuovoUtente"
          @chiudiForm="chiudiForm"
        ></nuovo-utente>
      </keep-alive>

      <recupero-password
        :attivo="recuperoPassword"
        @chiudiForm="chiudiForm"
      ></recupero-password>
    </div>
  </div>
</template>

<script>
//import { mapActions } from "vuex";
//import axios from "axios";
import api from "@/services/EventService.js";
import nuovoUtente from "@/components/nuovoUtente.vue";
import recuperoPassword from "@/components/recuperoPassword.vue";

export default {
  name: "Login",

  components: { nuovoUtente, recuperoPassword },

  data() {
    return {
      isLoggingIn: false,
      value: true,
      authErr: false,
      statoAPI: true,
      nuovoUtente: false,
      recuperoPassword: false,
      form: {
        email: "",
        password: "",
      },
      showError: false,
      rules: {
        required: (value) => {
          return !!value || this.$i18n.t("campoObbligatorio");
        },
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$i18n.t("login.emailNonValida");
        },
      },
    };
  },
  mounted() {
    // Rimuoviamo il token JWT vecchio dal localStorage
    localStorage.removeItem("jwt_token");
    this.$store.commit("resetSessione");
    this.checkAlive();
  },
  computed: {
    getStatoAPI: {
      get: function() {
        return this.$store.state.statoWS;
      },
    },
  },

  methods: {
    goRinnovi() {
      window.location.href = "https://segreteria.patristicum.org/iscrizioni/";
    },
    lingua(flag) {
      this.$i18n.locale = flag;
    },

    chiudiForm() {
      this.nuovoUtente = false;
      this.recuperoPassword = false;
    },
    async checkAlive() {
      api
        .get("CheckAlive/immatricolazioni")
        .then((resp) => {
          if (resp.status == 200) {
            this.$store.state.statoWS = true;
          } else {
            this.$store.state.statoWS = false;
          }
        })
        .catch(function() {
          this.$store.state.statoWS = false;
        });
    },

    esitoLogin(esito) {
      if (esito.status == 200) {
        this.$store.state.parametri = esito.data;
        localStorage.setItem("jwt_token", esito.data.tokenJWT);
        // GGG Override per test in produzione
        //this.$store.state.parametri.semestre = "2";
        //this.$store.state.parametri.statoSeminariLetture = true;

        if (
          esito.data.statoDomanda == "PRESENTATA" ||
          esito.data.statoDomanda == "BOZZA"
        ) {
          this.$store.dispatch("recuperoDatiDBEvent");
          this.$router.push("/immatricolazioni");
        } else {
          this.$swal.fire({
            confirmButtonClass: "btn-action darken-2 white--text btn",
            cancelButtonClass: "primary darken-1",
            title: this.$t("login.domandaInLavorazione"),
            //text: this.$t("salvaDati.fine.testo"),
            //text: JSON.stringify(this.$store.getters.riepilogoGenerale),
            icon: "warning",
            confirmButtonText: "OK",
          });
        }

        this.authErr = false;
      } else {
        this.authErr = true;
        this.$store.state.parametri = null;
      }
    },
    resetErrors() {
      //this.authErr = false;
    },
    async checkLogin() {
      this.authErr = false;

      if (this.$refs.form.validate()) {
        try {
          // Creiamo una copia fresca dei dati del form
          const formData = {
            email: this.form.email,
            password: this.form.password,
          };

          // Attendiamo la risposta dell'azione LogIn
          const response = await this.$store.dispatch("LogIn", formData);

          // Verifichiamo lo stato della risposta
          if (response.status === 200) {
            this.esitoLogin(response);
          } else {
            // Gestiamo esplicitamente la risposta di errore
            this.authErr = true;
            // Reset della password per facilitare un nuovo tentativo
            this.form.password = "";
          }
        } catch (error) {
          console.error("Errore imprevisto durante il login:", error);
          this.authErr = true;
          this.form.password = "";
        }
      }
    },
  },
};
</script>

<style scoped>
.testopiccolo {
  font-size: 11px;
}

.titolocard {
  font-size: 20px;
  color: black;
  background: gray !important;
}

.gradient-custom-2 {
  /* fallback for old browsers */
  background: #c8a501 !important;
}

.semi-transparent {
  background-color: rgba(255, 255, 255, 0.35) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
}

.login-card {
  overflow: hidden;
  border-radius: 16px !important;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2) !important;
  transition: all 0.3s ease;
}

.login-card:hover {
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3) !important;
}

.left-panel {
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
}

.login-section {
  padding: 2rem 0;
}

.language-selector {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 100;
  display: flex;
  align-items: center;
}

.white-divider {
  border-color: rgba(255, 255, 255, 0.5) !important;
  margin: 1.5rem 0;
}

.login-form {
  max-width: 400px;
  margin: 0 auto;
}

.login-form-panel {
  background-color: rgba(255, 255, 255, 0.7) !important;
  border-radius: 0 16px 16px 0;
}

.login-form-panel .card-body {
  background-color: transparent;
}

@media (max-width: 991.98px) {
  .left-panel {
    border-radius: 16px 16px 0 0;
  }

  .login-form-panel {
    border-radius: 0 0 16px 16px;
  }
}

@media (min-width: 768px) {
  .gradient-form {
    height: 100vh !important;
  }
}

@media (min-width: 769px) {
  .gradient-custom-2 {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

@media (max-width: 768px) {
  .language-selector {
    background-color: rgba(0, 0, 0, 0.2);
    padding: 5px;
    border-radius: 8px;
  }

  .language-selector .v-btn {
    width: 36px;
    height: 36px;
    min-width: 0;
  }

  .language-selector .text-body-1 {
    font-size: 0.75rem !important;
  }
}

.input-field {
  border-radius: 8px;
}

.input-field >>> .v-input__slot {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.input-field:hover >>> .v-input__slot {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.registration-btn {
  min-width: 200px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: all 0.3s ease;
  background-color: rgba(255, 255, 255, 0.8);
}

.registration-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}

.blink-text {
  animation: blink 2s ease-in-out infinite;
}
</style>
